import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Shell } from './Shell.js';
import './styles.css';
import './skin.css';
import './shell.css';
import { applyStoredTheme } from './state/theme.js';
import { installChunkRecovery } from './nav/lazy-page.js';
import { watchKeyboard } from './state/keyboard.js';

/*
 * Тема — до первой отрисовки.
 *
 * Профиль придёт с сервера через сотни миллисекунд, и всё это время
 * человек со светлой темой смотрел бы на тёмный экран, который потом
 * моргает. Запомненный выбор применяется раньше, чем React нарисует
 * первый кадр.
 */
applyStoredTheme();

// Куски прошлой сборки после выкладки — перезагрузкой, а не серым экраном.
installChunkRecovery();

// Клавиатура телефона: пока печатают, шторки встают над ней, а не под ней.
watchKeyboard();

const container = document.getElementById('root');
if (!container) throw new Error('Не найден корневой элемент #root');

createRoot(container).render(
  <StrictMode>
    <Shell />
  </StrictMode>,
);
